import { axiosWithAuth } from "../../helpers";

export const permissionsService = {
	getPermissions,
	addRolePermissions,
	deleteRolePermissions,
};

const API_URL = process.env.REACT_APP_API_URL;

const PAGE_SIZE = 100;

function getPermissions() {
	return axiosWithAuth({
		url: `${API_URL}/api/permissions`,
		method: "GET",
		params: {
			page_index: 0,
			page_size: PAGE_SIZE,
		},
	});
}

function addRolePermissions(rolePermission) {
	return axiosWithAuth({
		url: `${API_URL}/api/roles/${rolePermission.roleId}/permissions/${rolePermission.permissionId}`,
		method: "PUT",
		data: {
			role_id: rolePermission.roleId,
			permission_id: rolePermission.permissionId,
		},
	});
}

function deleteRolePermissions(rolePermission) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/roles/${rolePermission.roleId}/permissions/${rolePermission.permissionId}`,
	};

	return axiosWithAuth(options);
}
